import React, { useState, useEffect } from 'react';

/**
 * Draw a standar input with a label, if isn´t send label then this downt draw
 * @param {string} value - The value of the input
 * @param {string} name - The name of the input
 * @param {string} label - The label of the input
 * @param {function} change - The function to call when the input change
 * @param {string} type - The type of the input
 * @param {string} containerStyle - The style of the container
 * @param {string} labelStyle - The style of the label
 * @param {string} inputStyle - The style of the input
 * @param {string} placeholder - The placeholder of the input
 * @returns 
 */
const InputLabel = (p) => {
    const value = p.value ?? "";
    const name = p.name ?? "";
    const label = p.label ?? "";
    const change = p.change ?? (() => { });
    const type = p.type ?? "text";
    const placeholder = p.placeholder ?? "";
    const containerStyle = p.containerStyle ?? "form-group bw-500 mt-2 mb-2";
    const labelStyle = p.labelStyle ?? "text-bold ps-2";
    const inputStyle = p.inputStyle ?? "form-control shadow-sm round-m";
    return (
        <div className={containerStyle}>
            <label className={labelStyle}>{label}</label>
            <input type={type} className={inputStyle} name={name} value={value} onChange={change} placeholder={placeholder} autoComplete='off' />
        </div>
    )
}

export default InputLabel;